import React from 'react';
import { Container } from '@mui/material';
import SaidaAlterarDatas from '../components/saida/SaidaAlterarDatas';

const SaidaAlterarDatasPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <SaidaAlterarDatas />
    </Container>
  );
};

export default SaidaAlterarDatasPage;
